// 登録者名の解決。created_by_user_id はサーバ設定列(キャッシュ同梱)で、名前はオンライン時に解決する。
// AreaDetailPage / ConstructionDetailPage で完全重複していた effect を共通化。
import { useEffect, useState } from "react";
import { PageContext } from "../pages/ConsolePages/PageContext";
import { formatUserWithGroup } from "./userDisplay";

export function useCreatorName(pageContext: PageContext, userId: string | null): string {
  const [creatorName, setCreatorName] = useState<string>("-");

  useEffect(() => {
    let active = true;
    const fetchCreator = async () => {
      if (userId == null || !pageContext.api.isOnline) {
        return;
      }
      try {
        const user = await pageContext.api.user_data.getFromId({ id: userId });
        if (active) {
          setCreatorName(formatUserWithGroup(user));
        }
      } catch (e) {
        console.warn("creator lookup failed", e);
      }
    };
    fetchCreator();
    return () => { active = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  return creatorName;
}
